import anchorTo from './lib/anchorTo';
import animateTo from './lib/animateTo';
import debounce from './lib/debounce';
import elementOffsetTop from './lib/elementOffsetTop';
import events from './lib/events';
import forEach from './lib/forEach';
import isExplorer from './lib/isExplorer';
import isInt from './lib/isInt';
import isNan from './lib/isNan';
import safeScrollTop from './lib/safeScrollTop';
import scrollDirection from './lib/scrollDirection';
import touchable from './lib/touchable';

const purejs = {
  anchorTo,
  animateTo,
  debounce,
  elementOffsetTop,
  events,
  forEach,
  isExplorer,
  isInt,
  isNan,
  safeScrollTop,
  scrollDirection,
  touchable,
};

export default purejs;
